__turbopack_context__.v({
  "action": "marketing-email-opted-in-dialog-module-scss-module__tfhzgG__action",
  "actions": "marketing-email-opted-in-dialog-module-scss-module__tfhzgG__actions",
  "content": "marketing-email-opted-in-dialog-module-scss-module__tfhzgG__content",
  "iframe": "marketing-email-opted-in-dialog-module-scss-module__tfhzgG__iframe",
  "modal": "marketing-email-opted-in-dialog-module-scss-module__tfhzgG__modal",
});
